<template>
  <div class="column is-11-mobile is-7-tablet is-5-widescreen is-5-fullhd is-5-desktop" >
    <!-- TO DO when get obj -->
    <p v-if="review" class="is-size-14 mb20 has-text-centered">Thanks for your reviews!</p>
    <!-- <p v-else class="is-size-14 mb20 has-text-centered text-white">How was your order? Give a review!</p> -->
    <div class="order-details" v-if="vg_currentOrder.id">
      <div class="order-info is-flex justify-content-between">
        <div class="order-id">
          Order
          <span class="id">#{{ vg_currentOrder.id }}</span>
        </div>

        <div class="order-timestamp">
          <span class="order-time">{{ orderTime(vg_currentOrder) }}, </span>
          <span class="order-date">{{ orderDate(vg_currentOrder) }}</span>
        </div>
      </div>
      <div class="order-store is-flex">
        <img v-if="vg_currentOrder.location.images && getStorefeaturedImage(vg_currentOrder.location.images)" :src="getStorefeaturedImage(vg_currentOrder.location.images)" alt class="order-history-img is-block mr20" />
        <img v-else src="@/assets/img/icon-marker-green.svg" alt class="is-block mr20" />
        <div class="store-detail">
          <div class="store-name has-text-weight-semibold is-uppercase">
            <p class="text-dark">{{vg_currentOrder.location.display_name}}</p>
          </div>
          <div class="store-address">
            <p>{{vg_currentOrder.location.address ? vg_currentOrder.location.address.formatted_address : ''}}</p>
          </div>
        </div>
      </div>

      <!-- <div class="order-item"  v-for="(order, index) in vg_currentOrder.order_items" :key="'product'+index">
        <div class="order-item-left">
          <div class="order-srno">{{index + 1}}</div>
          <div class="order-product-name">{{order.product_name}} X {{order.unit}}</div>
        </div>
        <div class="order-item-right">
          <div class="order-weight" v-if="order.weight">{{order.weight.toFixed(2)}}g</div>
          <div class="order-price order-record-price">$ {{order.price.toFixed(2)}}</div>
        </div>
      </div> -->

      <div  class="order-item">
        <table class="cart-table order-show">
          <tr v-bind:key="'cart-item_' + index" v-for="(product, index) in vg_currentOrder.order_items">
            <td class="td-product-name is-size-15"><div class="order-srno">{{ index + 1}}</div> {{ product.product_name  }}</td>
            <td  class="td-product-info text-right is-size-13">{{ product.weight ? product.weight : '0.00' }}{{ product.weighting_unit ? product.weighting_unit : '' }} X {{ product.unit }}</td>
            <td class="td-product-price text-right is-size-13">$ {{ (product.unit * product.price).toFixed(2) }}</td>
          </tr>
        </table>
      </div>

      <div class="order-subtotal has-text-right">
        Subtotal
        <span class="subtotal-price order-record-price">
          $ {{ subtotal }}
        </span>
      </div>

      <div class="order-subtotal has-text-right" v-if="promoCodeDiscount">
        Promo Code: {{ vg_currentOrder.order_promocodes[0].code}}
        <span class="subtotal-price order-record-price">
          - $ {{ promoCodeDiscount }}
        </span>
      </div>

       <div class="order-subtotal has-text-right" v-if="loyaltyDiscount">
        Points Used: {{ new Intl.NumberFormat().format(vg_currentOrder.order_loyalty[0].points_redeemed) }}
        <span class="subtotal-price order-record-price">
         - $ {{ loyaltyDiscount }}
        </span>
      </div>
      
      <div class="order-tax has-text-right">
        Tax
        <span class="tax-price text-dark order-record-price">$ {{ vg_currentOrder.tax ? vg_currentOrder.tax.toFixed(2) : '0.00' }}</span>
      </div>
      <div class="order-tax has-text-right" v-if="vg_currentOrder.order_receive_method == 'delivery'">
        Delivery fee
        <span class="tax-price text-dark order-record-price">$ {{ vg_currentOrder.delivery_fee ? vg_currentOrder.delivery_fee.toFixed(2) : '0.00'}}</span>
      </div>

      <div class="order-tax has-text-right" v-if="vg_currentOrder.order_receive_method == 'delivery'">
        Tip
        <span class="tax-price text-dark order-record-price">$ {{ vg_currentOrder.tip ? vg_currentOrder.tip.toFixed(2) : '0.00'}}</span>
      </div>

      <div class="order-total has-text-right">
        Total 
        <span class="total-price order-record-price" >$ {{ vg_currentOrder.total ? vg_currentOrder.total.toFixed(2) : '0.00' }}</span>
      </div>
      <div class="order-total has-text-right" v-if="vg_currentOrder.order_loyalty && (vg_currentOrder.order_loyalty.length > 0) && (vg_currentOrder.order_loyalty[0].points_earned > 0)">
        Points Earned
        <span class="total-price order-record-price">{{ new Intl.NumberFormat().format(vg_currentOrder.order_loyalty[0].points_earned) }}</span>
      </div>
      <div class="order-status-block is-flex justify-content-between align-items-center">
         <a href="#" @click.prevent="orderReceipt()"><strong>View Receipt</strong></a>
        <div class="order-status">
          <div class="status-text">Status: <span :class="vg_currentOrder.status == 'cancelled' ? 'cancelled-order has-text-danger' : 'has-text-green'">{{ vg_currentOrder.status }}</span></div>
          <!-- <div class="status">{{ vg_currentOrder.status }}</div> -->
          <!-- (Preparing Order) Text Hidden. Remove is-hidden class to make it visible
           <div class="status is-hidden">Preparing Order</div>  -->
        </div>
        <!-- <a href="#" @click.prevent="reOrder()" class="button is-primary view-status">Reorder</a> -->
      </div>
    </div>
     <div class="order-details" v-else>
       <div class="order-info is-flex justify-content-between">
         <p class="has-text-black">{{ pastOrders.length > 0 ? 'Please select past order from left bar.' : 'No order available.' }}</p>
       </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
import 'moment-timezone';
import Helpers from '@/Components/Helpers/Helpers';

export default {
  computed: {
    ...mapGetters({
      vg_currentOrder: "orderhistory/currentOrder",
      // order: "orderhistory/currentOrder",
      vg_allOrders: "orderhistory/allOrders",
    }),
    pastOrders() {
      return  _.filter(this.vg_allOrders.orders, function(order) {
        return order.status =='completed';
      });
    },
    
    promoCodeDiscount() {
      if( this.vg_currentOrder.order_promocodes && (this.vg_currentOrder.order_promocodes.length > 0) ){
       return this.vg_currentOrder.order_promocodes[0].code ? this.vg_currentOrder.order_promocodes[0].applied_value.toFixed(2) : 0;
      }
      return 0;
    },

    loyaltyDiscount() {
      if( this.vg_currentOrder.order_loyalty && (this.vg_currentOrder.order_loyalty.length > 0) && (this.vg_currentOrder.order_loyalty[0].reward_amount > 0) ){
       return this.vg_currentOrder.order_loyalty[0].reward_amount.toFixed(2);
      }
      return 0;
    },

    subtotal () {
      // if(this.promoCodeDiscount){
      //   return ( parseFloat(this.vg_currentOrder.sub_total) + parseFloat(this.promoCodeDiscount)).toFixed(2);
      // }
      return this.vg_currentOrder.sub_total ? this.vg_currentOrder.sub_total.toFixed(2) : '0.00';
    },

  },

  props: ['review'],

  methods: {
    /**
   * Get store featured image
   */
    getStorefeaturedImage(images) {
      return Helpers.getStoreFeaturedImage(images);
    },

    // get order time and date
    orderTime(order) {
      if (_.isEmpty(order)) return '';
      return moment.utc(order.created_at).tz(order.location.address && order.location.address.timezone_id ? order.location.address.timezone_id : 'America/Toronto').format('h:mm a');
    },

    // get order date
    orderDate(order) {
      if (_.isEmpty(order)) return '';
      return moment.utc(order.created_at).tz(order.location.address && order.location.address.timezone_id ? order.location.address.timezone_id : 'America/Toronto').format('MMM DD YYYY');
    },
    /**
     * Order receipt
     */
    orderReceipt() {
   
       bus.$emit("show-modal-order-recepit", {
        order: this.vg_currentOrder,
        modal: true
      });
    },
    
    ...mapActions({
      // va_setCurrentOrder: "orderhistory/setCurrentOrder",
      // va_spinner: "spinner/setSpinner",
      // va_snackbar: "snackbar/setSnackbar",
      // va_setCartItems: "cart/setCartItems",
      // va_setSelectedStore: "cart/setSelectedStore"
    })
  }
};
</script>
<style scoped>
.order-history-img {
  object-fit: contain;
}
</style>